import { graphql } from '../../gql';

export default graphql(`
    mutation enableUserTOTP($input: ToggleUserTOTPInput!) {
        enableUserTotp(input: $input) {
            ok
            token
        }
    }
`);
